module.exports = __webpack_public_path__ + "static/cx-hero-bg-220a7b53396ec7ab867836f06b0adb7c.jpg";